export default __webpack_public_path__ + "navigation-guide-device-notification-1200-1ff71f7affe1511134dd1e95041dd87c.png";